import * as React from 'react';
import { getText, getConfig } from '../../helpers';
import TileCarousel from '../_common/tile-carousel';
import SectionTitle from '../_common/section-title';

const slickOptions = getConfig('components.carouselOptions');
const title = getText('generic.relatedBlueprints');

const relatedDatasets = function RelatedDatasets({ blueprintRelatedTiles, className, scrollTo }: RelatedBlueprintDatasetsProps) {
    if (blueprintRelatedTiles && !blueprintRelatedTiles.MarketPlaceBlueprintDatasetSolution) return null;
    return (
        <div className="page-section">
            <div className="page-section__inner">
                <SectionTitle hash="required-datasets-solutions" text={title} onClick={scrollTo} />
            </div>
            <TileCarousel
                dataIds={
                    blueprintRelatedTiles &&
                    blueprintRelatedTiles.MarketPlaceBlueprintDatasetSolution.sort(
                        (a: MarketPlaceBlueprintDatasetSolution, b: MarketPlaceBlueprintDatasetSolution) => a.FormOrder - b.FormOrder
                    ).map(x => {
                        if (x.KeyMarketplaceDataset === null) return x.KeyPlatformService;
                        return x.KeyMarketplaceDataset;
                    })
                }
                slickOptions={slickOptions}
                className={className}
            />
        </div>
    );
};

export default React.memo(relatedDatasets);
